<template>
    <div class="panel panel-default" data-testid="order-detail-shipment">
        <div class="panel-heading">
            <h4>{{ label }}</h4>
        </div>
        <div v-if="shipment" class="panel-body od-stack">
            <od-key-value-list :items="items" />
            <div v-if="shipment.trackingNumber" class="od-field">
                <p class="od-field__label">Tracking</p>
                <od-mono-pill :value="String(shipment.trackingNumber)" />
            </div>
            <div v-if="shipment.bookingId" class="od-field">
                <p class="od-field__label">ID prenotazione</p>
                <od-mono-pill :value="String(shipment.bookingId)" />
            </div>
            <a
                v-if="shipment.trackingUrl"
                :href="shipment.trackingUrl"
                class="od-link"
                target="_blank"
                rel="noopener noreferrer"
            >Apri tracking <od-icon name="external-link" /></a>
        </div>
    </div>
</template>

<script>
import OdIcon from './OdIcon.vue';
import OdKeyValueList from './OdKeyValueList.vue';
import OdMonoPill from './OdMonoPill.vue';
import { formatDate } from './orderDetailHelpers';

export default {
    name: 'OrderShipmentCard',
    components: { OdIcon, OdKeyValueList, OdMonoPill },
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    computed: {
        label() {
            return this.order.ui?.labels?.shipment || 'Spedizione';
        },
        shipment() {
            return this.order.shipment || null;
        },
        items() {
            const s = this.shipment;

            return [
                { label: 'Corriere', value: s.carrier || '—', strong: true },
                { label: 'ID vettore', value: s.carrierId != null ? String(s.carrierId) : '—', mono: s.carrierId != null },
                { label: 'Numero rif.', value: s.refNumber != null ? String(s.refNumber) : '—', mono: s.refNumber != null },
                { label: 'Documento', value: s.documentAt || '—' },
                { label: 'Estratto il', value: formatDate(s.extractedAt) },
                { label: 'Mail inviata', value: s.mailed ? 'Sì' : 'No' },
                { label: 'Messaggio spedizione', value: s.shippedMessage || '—' },
                { label: 'Spedito il', value: formatDate(s.shippedAt) },
            ];
        },
    },
};
</script>
